import React from "react";
import {getDateFormat} from "../../../../../utils/functions";

const JMeta = (parent) => {
    const record = parent.record;

    if(!record.journal_meta)
        return ''
    else if(record.journal_meta.length <= 0)
        return '';

    return (
        <div className="mt-65 journal-detail-change">
            <div className="d-flex justify-content-between align-items-center mb-px-26">
                <div className="d-flex align-items-center">
                    <h3 className="con-title">저널 변경 정보</h3>
                </div>
            </div>
            <div>
                <table className="table table-lightgray">
                    <colgroup>
                        <col width="15%"/>
                        <col width="10%"/>
                        <col width="70%"/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th scope="col" className="">유형</th>
                        <th scope="col" className="">날짜</th>
                        <th scope="col" className="text-left">내용</th>
                    </tr>
                    </thead>
                    <tbody>
                    {record.journal_meta && record.journal_meta.map((item, num) => {
                        return (
                            <tr key={num}>
                                <td>{item.meta_name}</td>
                                <td>{getDateFormat(item.meta_date)}</td>
                                <td className="text-left">{item.meta_value}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default JMeta;
